// extracted by mini-css-extract-plugin
module.exports = {"container":"FactorDemo_container__3VdzX","primary":"FactorDemo_primary__3j9A8"};